/* eslint-disable complexity */
import { ConvertHistoryStatus } from '@conversionProgram/src/models';
import { CurrencyType, serverCurrencyToSystemCurrency } from '@wolffun/system-currency';
import { createSelectorHook, useDispatch } from 'react-redux';

/** Typed selector */
export const useTypedSelector = createSelectorHook();
/** Typed dispatcher */

export const useTypedDispatch = useDispatch;
export const parseConvertHistory = transaction => {
  const {
    status,
    created,
    THC,
    THG,
    term,
    hash,
    season
  } = transaction || {};
  return {
    status: typeof status === 'number' ? status : ConvertHistoryStatus.CANCELLED,
    created: typeof created === 'string' ? created : '',
    THC: THC ? serverCurrencyToSystemCurrency(THC) : {
      token: CurrencyType.THC,
      value: ''
    },
    THG: THG ? serverCurrencyToSystemCurrency(THG) : {
      token: CurrencyType.THG,
      value: ''
    },
    term: typeof term === 'number' ? term : 0,
    hash: typeof hash === 'string' ? hash : '',
    season: typeof season === 'string' ? season : ''
  };
};